import i18next from 'i18next';

export const handleTranslation = (text: string) => {
  const checkText = text !== i18next.t(text) ? i18next.t(text) : null;
  return checkText;
};
